module.exports = __webpack_public_path__ + "static/select3-810d5350055a2607520694f470839d39.png";